// export const DST_HOST = "https://office.dok32.dst.uz/";
export const DST_HOST = "https://prelive-office.dok32.com/";
export const LIVE_HOST = "https://office.dok32.com/";
export const SANCHO_HOST = "http://10.10.1.53:8080/";
export const LOCAL_HOST = "http://127.0.0.1:8080/";

export const settings = {};

settings.host = localStorage.getItem("host") || LIVE_HOST;
